module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "calib-page"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isETUDConnected),
      expression: "isETUDConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content is-large"
  }, _vm._l((_vm.calibInstruction), function(line) {
    return _c('p', [_vm._v(_vm._s(line))])
  })), _c('button', {
    staticClass: "button is-large is-primary",
    attrs: {
      "disabled": !_vm.isConnected
    },
    on: {
      "click": _vm.calibrate
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_calib']))]), _c('button', {
    staticClass: "button is-large",
    attrs: {
      "disabled": !_vm.isCalibrated
    },
    on: {
      "click": _vm.skip
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_skip_calib']))]), _c('button', {
    staticClass: "button is-large",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isETUDConnected),
      expression: "!isETUDConnected"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "message is-danger is-centered"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_cannot_conect']))]), _c('div', {
    staticClass: "message-body"
  }, [_c('div', {
    staticClass: "content has-text-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_1']))]), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_2']))]), _c('li', [_vm._v(_vm._s(_vm.tokens['msg_cannot_conect_3']))])])])])])]), _c('div', {
    staticClass: "is-bottom-right"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isETUDConnected
    },
    on: {
      "click": _vm.showETUDOptions
    }
  }, [_vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5669a8c7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/task/CalibPage.vue
// module id = 422
// module chunks = 0